export default __webpack_public_path__ + "7a1bece81fb3457f6c2d0058d28d532d.svg";